<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-divider orientation="left">{{ $t('报修信息') }}</a-divider>
            <a-col :span="8">
              <a-form-model-item :label="$t('报修人')" prop="repairName">
                <a-input v-model="model.repairName"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('报修人电话')" prop="repairPhone">
                <a-input v-model="model.repairPhone"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('报修户地址')" prop="repairAddress">
                <a-input v-model="model.repairAddress"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('报修时间')" prop="createTime">
                <a-input v-model="model.createTime"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('报修描述')" prop="repairDescription">
                <a-textarea v-model="model.repairDescription" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
            <template>
              <a-divider orientation="left">{{ $t('指派和处理信息') }}</a-divider>
              <a-col :span="24">
                <a-form-model-item :label="$t('处理人类型')" prop="fixType">
                  <a-select :placeholder="$t('请选择处理人类型')" v-model="model.fixType" @change="fixTypeChange">
                    <a-select-option :value="0">{{ $t('指定人员') }}</a-select-option>
                    <a-select-option :value="1">{{ $t('指定班组') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <template v-if="model.fixType == 0">
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理人员选择')" prop="fixUserId">
                    <a-select :placeholder="$t('请选择人员')" v-model="model.fixUserId" @change="handleChange">
                      <a-select-option :value="item.userId" v-for="item in userList">{{item.userName}}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item :label="$t('处理人电话')" prop="fixPhone">
                    <a-input v-model="model.fixPhone" :placeholder="$t('请输入处理人电话')"></a-input>
                  </a-form-model-item>
                </a-col>
              </template>
              <template v-else>
                <a-col :span="24">
                  <a-form-model-item :label="$t('处理班组选择')" prop="fixTeamId">
                    <a-select :placeholder="$t('请选择班组')" v-model="model.fixTeamId">
                      <a-select-option :value="item.id" v-for="item in teamList">{{item.teamName}}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </template>
              <a-col :span="24">
                <a-form-model-item :label="$t('报修修理描述')" prop="fixDescription">
                  <a-textarea v-model="model.fixDescription" :placeholder="$t('请输入报修修理描述')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </template>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  export default {
    mixins: [JeecgListMixin],
    name: 'modal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        validatorRules: {},
        url: {
          queryById: "/jeecg-charge/oa/userComplaints/queryById",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          teamList: "/jeecg-engineering/ticket/ticketsTeam/list",
          list: "null",
        },
      }
    },
    methods: {
      init(row){
        this.visible = true;
        this.title = this.$t('详情');
        this.disableSubmit = true;
        this.model = JSON.parse(JSON.stringify(row));
        this.getuserList();
        this.getteamList();
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      getteamList(){
        this.teamList = [];
        getAction(this.url.teamList).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.teamList.push({
                teamName: item.teamName,
                id: item.id,
              });
            });
          }
        });
      },
      getuserList(){
        this.userList = [];
        getAction(this.url.userList).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.userList.push({
                userId: item.userId,
                userName: item.userName,
                userPhone: item.userPhone,
              });
            });
          }
        });
      },
    }
  }
</script>